<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: 'App',
    beforeCreate(){
        let userInf = localStorage.getItem('userInf')!=='' ? JSON.parse(localStorage.getItem('userInf')) : '';
        if(userInf && userInf.userType=='2'){
            this.http.getauthinfo()
                .then(res=>{
                    let authinf=JSON.stringify(res);
                    localStorage.setItem('authinf',authinf);
                });
        }else if(userInf && userInf.userType=='1'){
            this.http.whinfogetauth()
                .then(res => {
                    let authinf = JSON.stringify(res);
                    localStorage.setItem('authinf', authinf);
                })
        }
    }
}
</script>
<style lang="scss">
  /*距离间隔*/
  $b30:30px;
  $b15:15px;
  /*字体大小*/
  $font-26:26px;
  $font-14:14px;
  $font-12:12px;
  /*主题色*/
  $color-default:#1054FF;
  /*警示色*/
  $color-yz:#e02a37;/*严重*/
  $color-g:#ED5565;/*高*/
  $color-z:#f3822e;/*中*/
  $color-d:#F8AC59;/*低*/
  $color-blue:#1AB394;/*绿*/
  $color-grey:#9AABB8;/*灰*/
  /*背景色*/
  $background-white:#fff;
  $background-grey:#F7FAFF;
  $background-default:#1054FF;
  /*边框颜色*/
  $border-1:#F7FAFF;/**/
  $border-2:#EBEDF2;/*输入框*/
  $border-3:#eff3f5;/*分割线*/
  /*字体颜色*/
  $font-34495e:#34495e;
  $font-ED5565:#ED5565;






  body{ background:$background-grey; margin: 0; padding: 0;font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif; color: $font-34495e; font-size:$font-14;}
  .table_box{ background: $background-white;padding:$b15; height: auto; overflow: hidden}
  .page_box{ padding-top:$b15; text-align: right}
  .btn_box{ margin-bottom:$b15}
  .el-button--primary,.el-button--primary:hover,.el-button--primary:focus{ background:$color-default; border-color: $color-default}
  .el-pagination.is-background .el-pager li:not(.disabled).active{ background: $color-default}
  .table_top{ padding: $b15; text-align: right; border-bottom: 1px #eee solid}
  .operation{ max-width: 800px}
  .page_box .page_left{ float: left; height: 28px; line-height: 28px}
  .my-form-item{ height: auto; position: relative; overflow: hidden}
  .my-form-item>span{
    position: absolute; text-align: right; display: block; line-height: 40px; left: 0; top: 0; font-size: $font-14; padding-right: 12px;
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
  }
  .ue_box .edui-default .edui-editor{
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
  }
  .tr{ text-align: right}
  input{outline:none;}
  .input_tishi{ font-size: $font-12; line-height: 20px; color: $color-grey}
  .el-radio-button__orig-radio:checked+.el-radio-button__inner{ background-color: $color-default; border-color: $color-default}
  .el-input__icon{ line-height: 34px}
  .el-table a{ color: $color-default; text-decoration: none}
  .el-table a:hover{ color: $color-default; text-decoration: underline}
  .upimg_close{ position: relative}
  .upimg_close i.el-icon-close{ position: absolute; left: 0; top: 0; width: 20px; height: 20px; display: block;background: #f56c6c; text-align: center; line-height: 20px; color: #fff; cursor: pointer}
  .my_alert{font-size: 13px;border-radius: 5px;width: 700px;padding:8px 25px;margin: 0px 0 25px 80px; display: inline-block}
  .my_alert.error{background: $background-grey;color: #ed5565;border: 1px #ed5565 solid;}
  .my_alert.success{background: $background-grey;color: #1ab394;border: 1px #1ab394 solid;}
  textarea{font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif; color: #606266}
  textarea::-webkit-input-placeholder,textarea::-moz-placeholder,textarea:-ms-input-placeholder {
    color: #c0c4cc;-webkit-font-smoothing:none;font: 400 13.3333px Arial;text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    -webkit-appearance: none;
  }
  .el-table{ font-size: 14px}
  .el-button{ border-radius: 5px}

  .tab,.tab li{ margin: 0; padding: 0; list-style: none}
  .tab{ border-bottom: 1px $border-2 solid; height: 42px; margin-bottom: 23px; font-size: 14px}
  .tab li{ float: left; cursor: pointer; margin-right: 47px}
  .tab li i{margin-right: 5px}
  .tab li span{ vertical-align: middle}
  .tab li.dq{ color: #1054FF; border-bottom: 4px #1054FF solid; height: 38px}
  .el-form-item__label{ color: $font-34495e}

  .el-table td, .el-table th.is-leaf{}
  .el-table .cell{ line-height: 20px}
  .el-table td{ height: 40px!important; padding: 0}
  .el-table th{ padding: 0 0 21px 0}
  .el-table__row>>>.el-link span{ color: #1054ff}

  .el-dialog__body{ padding: 0 15px}
  /*.el-dialog__header{ padding: 0 15px;}*/
  .el-dialog__header{ height: 55px; line-height: 55px; border-bottom: 1px #F7FAFC solid; padding: 0 17px; margin-bottom: 15px}
  .el-dialog__header .el-dialog__title{ font-size:14px;font-weight:bold;color:rgba(52,73,94,1)}
  .el-dialog__headerbtn{ top: 15px}
  .el-dialog__footer{ padding: 0 15px 15px 15px}
  /**字体颜色**/
  .mt0{ margin-top: 0!important;}
  .mt20{ margin-top: 20px!important;}
  .mr10{margin-right: 10px!important;}
  .mr40{ margin-right: 40px}
  .mb0{ margin-bottom: 0!important;}
  .mb12{margin-bottom: 12px!important;}
  .mb35{ margin-bottom: 35px!important;}
  .mb30{ margin-bottom: $b30!important;}
  .pt0{ padding-top: 0!important;}
  .pb0{ padding-bottom: 0!important;}
  .mt10{ margin-top: 10px!important;}

  /**新规范**/
  .p30{ padding: 30px}
  .p15{ padding: 15px}
  .pt15{ padding-top: 15px}
  .pr15{ padding-right: 15px}
  .pb15{ padding-bottom: 15px}
  .pl15{ padding-left: 15px}
  .mr0{margin-right: 0!important;}
  .mr15{margin-right: 15px!important;}
  .mr30{margin-right: 30px!important;}
  .fl{ float: left}
  .fr{ float: right}
  .tc{ text-align: center}
  .tr{ text-align: right}
  .mb15{ margin-bottom: 15px!important;}
  .textcolor-red{ color: #ED5565!important;}/*高*/
  .textcolor-serious{ color: #e02a37!important;}/*严重*/
  .textcolor-yellow{ color: #F8AC59!important;}/*低*/
  .textcolor-yellow2{ color: #f3822e!important;}/*中*/
  .textcolor-blue{ color: #1AB394!important;}
  .textcolor-grey{ color: #9AABB8!important;}
  .textcolor-default{ color: $color-default!important;}
  .font-16{font-size: 16px!important;}
  .font-12{font-size: 12px!important;}
  .font-14{font-size: 14px!important;}
  .font-26{font-size: 26px!important;}







  .assets_bg{ background-image: url("./assets/images/right_bg.png"); background-position: 220px 0; background-repeat: repeat-y}
  .assets_bg .main{ width: calc(100% - 235px)};
  .eltable_box{ background: #fff; padding: 15px}
  .el-table__body .el-table__row .cell{white-space: nowrap}
  .el-table thead{ color: #9AABB8; font-size: 14px; font-weight: 400}
  .el-radio-button--mini .el-radio-button__inner{ padding: 5px 13px}
  .el-table__empty-text{ color: #9AABB8}
  .el-textarea__inner{background-color: $background-grey;border-color: #F0F4F7;}
  .el-table--striped .el-table__body tr.el-table__row--striped td{ background: #fff}
  .mt15{ margin-top: 15px}


  .el-input__inner{ background-color: $background-grey; border-color: #F0F4F7; height: 34px; line-height: 34px}
  .el-input{ font-size: 12px}
  .btn_input_box {display: inline-block; margin-left: 16px; width: 380px;}
  .btn_input_box .input-with-select{width: 100%}
  .btn_input_box .el-input__inner{ background-color: #fff}
  .btn_input_box .el-input-group__append .el-button{ background-color: #fff!important; border-color: #F0F4F7!important; color: #1054FF!important;; border-left: none!important;}
  .el-button{ font-size: 12px; padding: 10px 16px}
  .btn_box{ font-size: 0}
  .el-input-group__append, .el-input-group__prepend{ background-color:$background-grey; border-color: #F0F4F7; color: #bbc8d2}
  .orderEditBox{ border: 1px #E7ECEF solid; background: #fff; border-radius: 4px; overflow: hidden; max-width: 800px}
  .orderEditBox .title{ height: 40px; line-height: 40px; padding: 0 15px; font-size: 14px; background: #FAFAFA; border-bottom: 1px #E7ECEF solid; margin-bottom: 22px; color: $font-34495e; font-weight: bold}
  .el-form--inline .el-form-item__content{ vertical-align: middle}
  .el-form-item__content{ line-height: 34px!important;}
  .el-table td, .el-table th.is-leaf{ border: none}
  .el-table__body tr:nth-child(2n+1) td{background:rgba(247,250,255,1)}
  .el-table__body tr.current-row td{ background: #e7eeff}
  .el-table__body tr:hover > td{background:#EFF3F5!important;}
  th{ font-weight: normal!important;}
  .el-table th div span{ vertical-align: middle}
  .el-link.el-link--default{ vertical-align: middle!important;}

  .header{ background: #fff; height: 74px; position: fixed; right: 0; top: 0; z-index: 98; width: calc(100% - 220px)}
  .logo{ width: 160px; height: 40px; background: url("./assets/images/logo.png") no-repeat center; margin: 18px auto 15px auto; display: block}
  .tuichu{ float: right; margin:25px 20px 0 0}
  .mymenu{width: 220px;position: fixed;left: 0; top: 0; bottom: 0;background: #fff;color:rgba(154,171,184,1);; z-index: 99;box-shadow:6px 0 14px rgba(237,241,248,0.69);}
  .mymenu dl{margin: 0; font-size: 14px; color: $font-34495e}
  .mymenu dt{ height: 52px; line-height: 52px; padding: 0 15px}
  .mymenu dt b,.mymenu dd b{ font-weight: normal}
  .mymenu dt,.mymenu dd{ cursor: pointer}
  .mymenu dt ~ dd{ display: none}
  .mymenu dt.router-link-active ~ dd{ display: block}
  .mymenu dt.router-link-active{ background:rgba(247,250,252,1); border-left: 4px #1054FF solid; color: #1054FF}
  .mymenu dt i{ margin-right: 10px; font-size: 22px}
  .mymenu dt span{ float: right; margin-top: 19px}
  .mymenu dd{ height: 52px; line-height: 52px; padding-left: 52px; margin: 0}
  .mymenu dd.router-link-exact-active,.mymenu dd.router-link-active{color: #1054FF}
  .main{ width: calc(100% - 250px); float: right; margin-top: 74px;padding: 0 15px 46px 15px}
  .mymenu dt a{ color: $font-34495e; text-decoration: none; display: block}
  .el-table th div{ display: block; line-height: 1}
  .buyssl_title{font-size:14px;font-weight:400;line-height:20px;color:rgba(52,73,94,1)}
  .buyssl_title2{font-size:14px;font-weight:400;line-height:20px;color:rgba(52,73,94,1); padding-bottom: 15px; border-bottom: 1px $border-2 solid}
  .certBrand_tab{ width: 100%; border-bottom:1px solid rgba(235,237,242,1); height: auto; overflow: hidden; padding: 0; margin: 0 0 20px 0}
  .certBrand_tab li{ float: left; list-style: none; line-height: 1; padding-bottom: 20px; padding-top: 14px; margin-right: 40px; position: relative; cursor: pointer}
  .certBrand_tab li.dq span{ display: inline-block; width: 100%; height: 4px; position: absolute; left: 0; bottom: 0; background: #1054FF; color: #1054FF}
  .el-table th div>div{ padding: 0}
  [class^="icon-"], [class*=" icon-"] { vertical-align: middle}
  .certbrandlogo{ display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 4px; background-size: cover;}
  .newtab{ font-size: 0; padding: 0; margin: 0}
  .newtab li,.newtab a{ display: inline-block; height: 32px; line-height: 32px; padding: 0 16px; background:rgba(255,255,255,1);border:1px solid rgba(235,237,242,1); font-size: 12px; border-radius: 4px; margin-right: 12px; position: relative; cursor: pointer}
  .newtab li.dq,.newtab a.dq{ border: 1px #1054FF solid}
  .newtab button{ height: 34px; line-height: 32px}
  .newtab li.dq [class*='icon-'],.newtab a.dq [class*='icon-']{ color: #1054FF!important;}
  .newtab li .icon,.newtab a .icon{ vertical-align: middle; display: inline-block}
  .newtab li .icon img,.newtab a .icon img{ vertical-align: middle; width: 20px; height: 20px}
  .newtab li .text,.newtab a .text{ vertical-align: middle}
  .newtab li.dq span.jt,.newtab a.dq span.jt{ position: absolute; right: 3px;bottom: 3px; width: 4px; height: 4px; background-image: url("./assets/images/tab_dq.png");}
  .my_label .el-form-item__label{ height: 34px!important;; line-height: 34px!important;}
  .el-form-item__label{ line-height: 34px}
  .newtab li i{position: absolute;
    right: -20px;
    top: -10px;
    height: 20px;
    line-height: 20px;
    background: red;
    color: #fff;
    padding: 0 8px;
    z-index: 99;
    font-style: normal;
    border-radius: 4px; font-size: 12px}
  .sslpayment_box{background:rgba(247,250,255,1); padding: 26px; text-align: right}
  .el-input-number__decrease, .el-input-number__increase{ background: #fff!important; border-color: $border-2!important;}
  .el-input-number .el-input__inner{ background: #fff!important;}
  .el-input-group__append .el-button{ background: #fff!important;; color: #1054FF!important;}
  .sslpayment_box p a{ color: #9AABB8; text-decoration: none}
  .sslpayment_box p a:hover{ color: #1054FF}
  .myboxstyle{ width: 100%; background: #fff; border-radius: 4px; overflow: hidden; position: relative}
  .myboxstyle .title{display: flex;align-items: center;padding:0 15px; background: #fff; height: 52px}
  .myboxstyle .myicon-recharge{ background: url("./assets/images/recharge.png") no-repeat; width: 22px; height: 22px; display: inline-block; vertical-align: middle; margin-right: 10px; font-size: 16px; background-size: 22px 22px}
  .myboxstyle .myicon-remittance{ background: url("./assets/images/remittance.png") no-repeat; width: 22px; height: 22px; display: inline-block; vertical-align: middle; margin-right: 10px; font-size: 16px; background-size: 22px 22px}
  .myboxstyle .myicon-details{ background: url("./assets/images/details.png") no-repeat; width: 22px; height: 22px; display: inline-block; vertical-align: middle; margin-right: 10px; font-size: 16px; background-size: 22px 22px}
  .myboxstyle .myicon-invoice_inf{ background: url("./assets/images/invoice-inf.png") no-repeat; width: 22px; height: 22px; display: inline-block; vertical-align: middle; margin-right: 10px; font-size: 16px; background-size: 22px 22px}
  .myboxstyle .myicon-mail{ background: url("./assets/images/mail.png") no-repeat; width: 22px; height: 22px; display: inline-block; vertical-align: middle; margin-right: 10px; font-size: 16px; background-size: 22px 22px}
  .myboxstyle .title .text{font-size:14px;font-weight:bold;line-height:22px;color:rgba(52,73,94,1);opacity:1;}
  .myboxstyle .content{padding:0 15px; position: relative}

  .form_text{ padding-top: 0px}
  .form_text dl{align-items: center; margin: 0 0 30px 0; position: relative; padding-left: 100px;min-height: 20px; height: auto; overflow: hidden}
  .form_text dt{font-size:14px;font-weight:400;line-height:20px;color:rgba(154,171,184,1);opacity:1; width: 85px; float: left; position: absolute; left: 0; top: 0}
  .form_text dd{font-size:14px;
    margin-left: 0;
    width: 100%;
    font-weight:400;
    line-height:20px;
    color:rgba(52,73,94,1);
    opacity:1;
    float: left;
  }
  .box_explain{ background: #fff; padding: 17px 30px; position: relative}
  .box_explain .decorate{ position: absolute; right: 182px; bottom: 0}
  .box_explain .title{ height: 28px; line-height: 28px;font-weight:bold;color:rgba(52,73,94,1); font-size: 0}
  .box_explain .title .title_text{ vertical-align: middle; margin-left: 10px;font-size:16px;}
  .box_explain .title .title_icon img{ vertical-align: middle}
  .box_explain .content{font-size:12px;font-weight:400;line-height:17px;color:rgba(52,73,94,1);}
  .table_box .table_box_title{font-weight:bold;line-height:22px;color:rgba(52,73,94,1);opacity:1; font-size: 0; margin: 0 0 24px 0; overflow: hidden; position: relative}
  .table_box .table_box_text{font-size:16px;}
  .table_box .table_box_tishi{ font-size: 12px;color: #9AABB8; margin-left: 8px; font-weight: normal}
  .el-button--primary.is-plain{ background-color: #fff; border-color: #1054FF; color: #1054FF}
  .el-form--label-top .el-form-item__label{ line-height: 20px; padding-bottom: 4px}
  .upImages{ width: auto; height: 110px; background: $background-grey; position: relative}
  .upImages li,.upImages ul{ margin: 0; padding: 0; list-style: none}
  .lock_ico{ background: url("./assets/images/lock.png") no-repeat; height: 28px; overflow: hidden; line-height: 1}
  .alipay-fill-icon{ height: 24px; line-height: 24px; background: url("./assets/images/alipay-fill.png") no-repeat left center; padding-left: 28px; display: inline-block}
  .el-link .el-link--inner span{ vertical-align: middle}
  .el-link .el-link--inner i{ font-size: 16px; margin-right: 7px}
  body.small .mymenu dt b,body.small .mymenu dd b,body.small .mymenu dt span,body.small .mymenu dd span{ display: none}
  body.small .mymenu{ width: 60px}
  body.small.assets_bg{ background-position: 60px 0}
  body.small .main { width: calc(100% - 90px )}
  body.assets_bg.small .main {width: calc(100% - 75px )}
  body.small .mymenu .router-link-active{ border-left: none}
  body.small .mymenu dl{ position: relative}
  body.small .mymenu dl div{ position: absolute; left: 60px; top: 0; z-index: 9999; display: none}
  body.small .mymenu dl dd{ display: none}
  body.small .mymenu:hover{ width: 220px}
  body.small .mymenu:hover ~.main{ width: calc(100% - 250px)}
  body.small .header{ width: calc(100% - 60px)}
  body.small .mymenu:hover dt.router-link-active ~ dd{ display: block}
  body.small .mymenu:hover b,body.small .mymenu:hover span{ display:inline-block}
  body.small .mymenu:hover dt.router-link-active{ border-left: 4px #1054FF solid}
  body.small .logo{ width: 60px; background: url("./assets/images/small_logo.png") no-repeat center}
  body.small .mymenu:hover .logo{ width: 220px; background: url("./assets/images/logo.png") no-repeat center }
  body.small .mymenu:hover~.header{ background: red}
  /*body.small .mymenu dl:hover div{ display: block; width: 300px; background: #000}*/
  /*body.small .mymenu dl:hover div dd,body.small .mymenu dl:hover div dd b{ display: block}*/
  .title_style1{ line-height: 1; border-left: 2px #1054FF solid; padding-left: 10px; font-size: 14px; color: #1054ff}
  .li_style1,.li_style1 li{ margin: 0; padding:0; list-style: none;}
  .li_style1 li{ position: relative; line-height: 20px; padding-left: 80px}
  .li_style1 li p{ margin: 0; padding: 0; min-height: 20px}
  .li_style1 li span{ position: absolute; left: 0; top: 0}

  .show_list,.show_list li{ margin: 0; padding: 0; list-style: none}
  .show_list{ padding: 15px}
  .show_list li{ line-height: 26px}

  .bug_content{ background: #F5F7FA; border: 1px #E4E7ED solid; padding: 0 22px; border-radius: 4px; height: auto; overflow: hidden}
  .bug_content p{ margin-top: 0; padding-top: 0}
  .bug_content img{ max-width: 100%}
  .el-image-viewer__close{ color: #fff; opacity: 1}

  button:focus{outline:0;}
  pre{
    display: block;
    font-family: -moz-fixed;
    white-space: pre;
    margin: 1em 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin: 0;
  }

  .el-link--primary.is-disabled span,.el-link--primary.is-disabled:hover span{ color: #9aabb8}
  .el-switch{ height: 24px;}
  .el-switch__core{ height: 24px; border-radius: 12px 12px 12px 12px; width: 60px; background: #9aabb8; border-color: #9aabb8}
  .el-switch.is-checked .el-switch__core{ background: #1AB394; border-color: #1AB394}
  .el-switch__core:after{ width: 20px; height: 20px}
  .el-switch__label.is-active{ display: block}
  .el-switch__label{ position: absolute; top: 0; height: 24px; line-height: 24px; display: none; z-index: 99; font-size: 12px}
  .el-switch__label span{ display: block; line-height: 24px; font-size: 12px; color: #fff}
  .el-switch.is-checked .el-switch__core::after{ margin-left: -21px}
  .el-switch__label--left.is-active{ text-align: right; right: 0}
  .el-switch__label--right{ margin-left: 10px}
  .el-switch__label--left{ margin-right: 10px}
  .input_tishi a{ color: #1054ff; text-decoration: none}
  .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus{border-color: #ED5565}
  .box_s1{ background: #fff}
  .security_right{ width: 525px;}
  .security_left{ width: calc(100% - 540px)}
  .box-sizing{
    box-sizing:border-box;
    -moz-box-sizing:border-box;
    -webkit-box-sizing:border-box;
  }
  .titles1{ height: 22px; padding:$b15; border-bottom: 2px $border-1 solid; background: $background-white; position: relative}
  .titles1 .title_text span{ display: inline-block; height: 22px;vertical-align: middle; line-height: 22px; overflow: hidden}
  .titles1 .title_text span img{ float:left;vertical-align: middle; height: 22px}
  .titles1 .el-switch{ position: absolute; right: 15px; top: 15px}
  .titles2{ font-size: $font-26; border-bottom: 1px $border-2 solid; line-height: 1; padding-bottom: $b15; margin-bottom: $b15; padding-right: 100px;overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;}
  .security_lists,.security_lists li{ margin: 0; padding: 0; list-style: none}
  .security_lists li{ padding: $b15 $b30; border-bottom: 2px $border-1 solid}
  .security_lists li h1{ font-size: $font-14; margin: 0; font-weight: normal; margin-bottom: $b15; line-height: 1}
  .security_lists li h1 a{ color: $font-34495e}
  .security_lists li>div{ font-size: 0}
  .security_lists li>div>div{ display: inline-block; margin-right: 57px; margin-bottom: $b15; font-size: $font-12}
  .security_lists li>div>div span{ color: $color-grey}
  .security_lists li .tag_box a{ margin-bottom: 0}
  .tag_a{ font-size: $font-12; line-height: 26px; padding: 0 8px; display: inline-block; background: $background-grey; color: $font-34495e!important; margin-right: $b15; text-decoration: none; margin-bottom: $b15}
  .security_lists .tag_box a:last-child{ margin-right: 0}
  .security_lists div:last-child{ margin-bottom: 0}
  .security_lists a{ text-decoration: none}
  .fingerprint_box{ padding: $b15 $b30; background: $background-white}
  .warning_box{ padding:$b15 $b30; background: $background-white}
  .notice p{ margin: 0 0 8px 0; line-height: 1}
  .notice p:last-child{ margin-bottom: 0}
  .notice .el-form-item__label{line-height: 1; margin-bottom: $b15}
  .notice{ margin-bottom: 0; color: $color-grey}
  .notice p span{ color: $color-default}
  .notice_edit{ line-height: 1; margin-top: $b15}
  .notice_edit span{ margin-right: 2px}
  .warning_tishi{ line-height: 1; color: $color-g; margin: 0}
  .h_tab{ font-size: 0}
  .h_tab a{ height: 32px; border:1px $border-2 solid; font-size: 12px; display: inline-block; line-height: 32px; padding: 0 20px; border-radius: 4px; text-decoration: none; color: $font-34495e; margin-right: $b15}
  .h_tab a.dq{ background: $background-default; color: #fff; border-color: $background-default}
  .h_tab a:last-child{ margin-right: 0}
  .h_tab>span{ margin-right: $b15; font-size: 14px}
  .notice_list{ font-size: 0}
  .notice_list span{ height: 32px; border: 1px $border-2 solid; display: inline-block; padding: 0 8px; border-radius: 4px; font-size: 14px; margin-right: 15px}
  .notice_list span:last-child{margin-right: 0}
  .notice_list span i{ color: $color-grey}
  .notice_list .el-form-item__label{ line-height: 1; margin-bottom: $b15; padding: 0}
  .show_width{ max-width: 930px}
  .security_show_inf{ height: auto; overflow: hidden}
  .security_show_inf>div{ float: left; width: 50%; margin-top: $b15}
  .security_show_inf>div>span{ color: $color-grey}
  .security_box .show_content{ max-width: 800px;word-break:break-all;word-wrap:break-word;}
  .security_box{ border-bottom: 1px $border-2 solid; padding-bottom:$b15; font-size: $font-12; margin-bottom: $b15}
  .security_box:last-child{border-bottom: none}
  .show_content{ font-size: 14px; line-height: 19px; color: $font-34495e}
  .show_content a{ color: $color-default}
  .early_warning_left,.early_warning_right{ float: left; width: 50%}
  .early_warning_left{ border-right: 1px $border-2 solid}
  .early_warning_top{ height: auto; overflow: hidden}
  .early_warning_top ul,.early_warning_top ul li{ margin: 0; padding: 0; list-style: none}
  .early_warning_top li{ float: left; width: 25%; height: 60px; position: relative}
  .early_warning_top .package{ padding-left: 75px; font-size: $font-26; line-height: 35px}
  .package>span{ color: $color-grey; font-size: $font-14; display: block; line-height: 21px; float: left; clear: both; width: 100%; margin-bottom: 4px}
  .package img{ position: absolute; left: 0; top: 0}
  .early_warning_top li{;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;}
  .early_warning_top li:last-child{ border-right: 0}
  .early_warning_top .surplus{ border-right: 1px $border-2 solid; padding-left: 20px; font-size: $font-26; text-align: center}
  .early_warning_top .surplus>div{ display: inline-block; position: relative; text-align: left}
  .early_warning_top .surplus span{ display: block; font-size: $font-14; line-height: 21px; margin-bottom: 4px}
  .early_warning_top .surplus i{ display: inline-block; width: 6px; height: 6px; border: 3px #34495E solid; border-radius: 50%; overflow: hidden; font-size: 0; position: absolute; left: -20px; top: 4px}
  .early_warning_top .surplus i.icon-border-1{ border-color: #0e4ce6}
  .early_warning_top .surplus i.icon-border-2{ border-color: #ED5565}
  .early_warning_top .surplus i.icon-border-3{ border-color: #f8ac59}
  .new_table{ width: 100%; border-collapse: collapse; font-size: $font-14;}
  .new_table thead th{ color: $color-grey; padding: 0 15px; text-align: left; line-height: 1; height: 34px; vertical-align: top}
  .new_table td{  padding: $b15}
  .new_table tbody tr:last-child td{ border-bottom: 0}
  .new_table tbody td{ background: $background-grey; font-size: $font-14; border-bottom: 15px #fff solid}
  .early_warning_top{ position: relative}
  .time-select table{ width: 100%}
  .time-select .el-date-editor--time-select{ width: 100%}
  .el-link.el-link--danger{ color: $font-ED5565; vertical-align: middle}
  .verifycode{ width: 100%; height: auto; overflow: hidden}
  .verifycode .input{ width: calc(100% - 114px); float: left}
  .verifycode .btn{ width: 114px; float: left}
  .tinotifyaccepts_list>div{ margin-bottom: $b15}
  .tinotifyaccepts_list>div i,.tinotifyaccepts_list>div span{ vertical-align: middle}
  .tinotifyaccepts_list div:last-child{ margin-bottom: 0}
  .align-top{ vertical-align: top}
  .el-input__icon{ color: $font-34495e; font-size: 18px}
  .my-time-picker .el-input__suffix{ display: none}
  .my-time-picker .el-input__prefix{ right: 10px; left: auto}
  .my-time-picker .el-input__inner{ padding-left: $b15}
  .my_radio__label .el-radio__label{ display: none}
  .loophole_list>div{ width: 100%; float: none}
    .tag_del{ height: 24px; line-height: 24px; display: inline-block; border: 1px $border-2 solid; background: $background-grey; margin-right: $b15}
    .tag_del:last-child{ margin-right: 0}
    .tag_del span{ float: left; padding: 0 8px}
    .tag_del button{ display: inline-block; border: none; height: 24px; line-height: 24px; width: 24px; text-align: center; padding: 0; margin: 0; float: left; background: none; border-left: 1px $border-2 solid}

  .monitor_list{ margin: 0; padding: 0; height: auto; overflow: hidden}
  .monitor_list li{ margin: 0 0 15px 0; padding: 30px; list-style: none; background: #fff; height: auto; overflow: hidden}
  .monitor_list_left b{ display: block; margin-bottom: $b15; font-size: $font-26; line-height: 1; height: 26px;overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap}
  .monitor_list_left{ float: left; width: 25%; margin-top: 24px; font-size: $font-14}
  .monitor_list_center{ float: left;width: calc(75% - 1px)}
  .monitor_box_list div{ float: left; width: 33%; padding-left: 40px; position: relative; height: 30px; line-height: 30px; font-size: $font-14; box-sizing:border-box;-moz-box-sizing:border-box; /* Firefox */-webkit-box-sizing:border-box; /* Safari */; margin-bottom: $b30}
  .monitor_box_list div img{ position: absolute; left: 0; top: 0; width: 30px; height: 30px}
  .monitor_box_list div b{ display: inline-block; height: 24px; line-height: 24px; color: $font-ED5565; font-weight: normal; border: 1px $font-ED5565 solid; padding: 0 8px; margin-left: $b15; font-size: $font-12;}
  .monitor_box_list div b.zc{ border-color: $color-blue; color: $color-blue}
  .el-button--default.is-plain{ border-color: $font-34495e}
  .scrollbar-x .el-scrollbar__wrap{ overflow-x: auto}
  .el-form-item__error{ color: #ED5565}

  .el-tooltip__popper.is-light{ border: #fff; box-shadow: 0 0 10px rgba(0,0,0,0.2)}
  .el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after{border-color: transparent;border-style: solid;}
  .popper__arrow{ opacity: 0}
  .tishi_ico{ display: inline-block; background:url("assets/images/ts_ico.svg"); width: 14px; height: 14px}
</style>



// WEBPACK FOOTER //
// src/App.vue